import React from "react";
import styled from "styled-components";

const Usp = ({ children }) => <StyledUsp>{children}</StyledUsp>;

export default Usp;

const StyledUsp = styled.div`
  background: #f6f6f6;
  padding: 10px 7px;
  margin: 4px 0;
  display: inline-block;
  border-radius: 5px;
  font-size: 14px;
  line-height: 18px;
  width: 100%;
  text-align: left;
`;
